function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Layer from '@mozaic-ds/freemarker/js/modules/_layer.js';
var ReviewFilters = /*#__PURE__*/function (_lm$Composant) {
  function ReviewFilters(id) {
    var _this;
    _classCallCheck(this, ReviewFilters);
    _this = _callSuper(this, ReviewFilters, [id]);
    _this.init();
    return _this;
  }
  _inherits(ReviewFilters, _lm$Composant);
  return _createClass(ReviewFilters, [{
    key: "init",
    value: function init() {
      initLayerBtns();
      initFiltersRemoveBtns();
      initSearchField();
    }
  }]);
}(lm.Composant);
function initSearchField() {
  var searchForm = document.getElementById('review-search-form');
  if (!searchForm) return;
  var reviewFiltersForm = document.getElementById('review-filters-form');
  var searchInput = document.querySelector('.js-input-review-search');
  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    reviewFiltersForm.querySelector('input[name="reviewsKeywords"]').value = searchInput.value;
    reviewFiltersForm.submit();
  }, true);
}
function initLayerBtns() {
  var reviewFiltersForm = document.getElementById('review-filters-form');
  var filtersLayerOpenButton = document.querySelector('.js-layer-button');
  var filtersLayer = new Layer({
    'classContent': 'js-layer-filters',
    'isScrollEdge': false
  });
  if (filtersLayerOpenButton) {
    filtersLayerOpenButton.addEventListener('click', function () {
      filtersLayer.open();
      reviewFiltersForm.reset();
    });
  }
  var filtersLayerSubmitButton = document.querySelector('.js-layer-filters-submit');
  filtersLayerSubmitButton.addEventListener('click', function () {
    reviewFiltersForm.submit();
  });
  var filtersLayerCancelButton = document.querySelector('.js-layer-filters-reset');
  filtersLayerCancelButton.addEventListener('click', function () {
    resetForm(reviewFiltersForm);
  });
}
function initFiltersRemoveBtns() {
  var reviewFiltersRemoveBtns = document.querySelectorAll('.js-review-filters-remove-btn');
  reviewFiltersRemoveBtns.forEach(function (e) {
    e.addEventListener('click', function () {
      var paramName = e.getAttribute("data-param-name");
      window.location = removeParamFromUrl(paramName, window.location.href);
    });
  });
  var reviewFiltersForm = document.getElementById('review-filters-form');
  var filtersLayerSubmitButton = document.querySelector('.js-layer-filters-submit');
  var filtersLayerCancelButton = document.querySelector('.js-layer-filters-reset');
  var reviewFiltersResetAllBtn = document.querySelector('.js-reset-filters-btn');
  if (reviewFiltersResetAllBtn) {
    reviewFiltersResetAllBtn.addEventListener('click', function () {
      filtersLayerCancelButton.click();
      reviewFiltersForm.querySelector('input[name="reviewsKeywords"]').value = '';
      filtersLayerSubmitButton.click();
      return false;
    });
  }
}
function removeParamFromUrl(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}
function resetForm(form) {
  // clearing inputs
  var inputs = form.getElementsByTagName('input');
  for (var i = 0; i < inputs.length; i++) {
    switch (inputs[i].type) {
      // case 'hidden':
      case 'text':
        inputs[i].value = '';
        break;
      case 'radio':
      case 'checkbox':
        inputs[i].checked = false;
    }
  }

  // clearing selects
  var selects = form.getElementsByTagName('select');
  for (var i = 0; i < selects.length; i++) selects[i].selectedIndex = 0;

  // clearing textarea
  var text = form.getElementsByTagName('textarea');
  for (var i = 0; i < text.length; i++) text[i].innerHTML = '';
  return false;
}

// Add Sentry tag
lm.sentry.configureScope(function (scope) {
  scope.setTag("kobi.composant", "reviewFilters");
});
lm.DOMReady(function () {
  new ReviewFilters("reviewFilters");
});